var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSleepy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: 0,
    y: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_133)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,36.87799835205078,41.933998107910156)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,10.803000450134277,10.956999778747559)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,176,100)",
    fillOpacity: 1,
    d: " M10.552000045776367,0.009999999776482582 C10.553000450134277,2.187999963760376 9.876999855041504,4.311999797821045 8.616999626159668,6.0879998207092285 C7.35699987411499,7.864999771118164 5.576000213623047,9.204999923706055 3.5199999809265137,9.925000190734863 C1.465000033378601,10.644000053405762 -0.7639999985694885,10.706999778747559 -2.8559999465942383,10.102999687194824 C-4.948999881744385,9.5 -6.802000045776367,8.26099967956543 -8.159000396728516,6.558000087738037 C-9.517000198364258,4.855000019073486 -10.310999870300293,2.7720000743865967 -10.432000160217285,0.597000002861023 C-10.553000450134277,-1.5770000219345093 -9.994999885559082,-3.734999895095825 -8.835000038146973,-5.578000068664551 C-7.675000190734863,-7.421999931335449 -5.96999979019165,-8.857999801635742 -3.9579999446868896,-9.6899995803833 C-1.9450000524520874,-10.522000312805176 0.2770000100135803,-10.706999778747559 2.4000000953674316,-10.220000267028809 C2.5409998893737793,-10.187999725341797 2.6700000762939453,-10.116000175476074 2.7709999084472656,-10.01200008392334 C2.871999979019165,-9.907999992370605 2.940999984741211,-9.777000427246094 2.9690001010894775,-9.635000228881836 C2.996000051498413,-9.494000434875488 2.9820001125335693,-9.348999977111816 2.928999900817871,-9.215999603271484 C2.875999927520752,-9.083000183105469 2.7860000133514404,-8.968000411987305 2.6700000762939453,-8.885000228881836 C2.138000011444092,-8.505000114440918 1.6950000524520874,-8.013999938964844 1.3730000257492065,-7.446000099182129 C1.0499999523162842,-6.876999855041504 0.8550000190734863,-6.245999813079834 0.8009999990463257,-5.593999862670898 C0.746999979019165,-4.942999839782715 0.8360000252723694,-4.288000106811523 1.0609999895095825,-3.6740000247955322 C1.2860000133514404,-3.061000108718872 1.6410000324249268,-2.503999948501587 2.1029999256134033,-2.0420000553131104 C2.565999984741211,-1.5789999961853027 3.122999906539917,-1.2239999771118164 3.7360000610351562,-0.9990000128746033 C4.349999904632568,-0.7739999890327454 5.005000114440918,-0.6850000023841858 5.656000137329102,-0.7390000224113464 C6.308000087738037,-0.7929999828338623 6.939000129699707,-0.9879999756813049 7.507999897003174,-1.309999942779541 C8.076000213623047,-1.6330000162124634 8.567000389099121,-2.0759999752044678 8.946999549865723,-2.6080000400543213 C9.029999732971191,-2.7239999771118164 9.145000457763672,-2.813999891281128 9.277999877929688,-2.867000102996826 C9.41100025177002,-2.9200000762939453 9.555999755859375,-2.934000015258789 9.696999549865723,-2.9079999923706055 C9.83899974822998,-2.878999948501587 9.970000267028809,-2.809999942779541 10.074000358581543,-2.7090001106262207 C10.178000450134277,-2.6080000400543213 10.25,-2.4790000915527344 10.281999588012695,-2.3380000591278076 C10.460000038146973,-1.5679999589920044 10.550999641418457,-0.7799999713897705 10.552000045776367,0.009999999776482582z"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "rgb(244,176,101)",
    fontSize: 11,
    fontFamily: "Avenir LT Std",
    fontStyle: "normal",
    fontWeight: 900,
    "aria-label": "z",
    transform: "matrix(1,0,0,1,46.25,56.4379997253418)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    d: " M5.13,0 C5.13,0 5.13,-1.32 5.13,-1.32 C5.13,-1.32 2.16,-1.32 2.16,-1.32 C2.16,-1.32 5.06,-3.76 5.06,-3.76 C5.06,-3.76 5.06,-5.35 5.06,-5.35 C5.06,-5.35 0.44,-5.35 0.44,-5.35 C0.44,-5.35 0.44,-4.03 0.44,-4.03 C0.44,-4.03 3.15,-4.03 3.15,-4.03 C3.15,-4.03 0.37,-1.65 0.37,-1.65 C0.37,-1.65 0.37,0 0.37,0 C0.37,0 5.13,0 5.13,0z",
    style: {
      display: "inherit"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepy);
export default __webpack_public_path__ + "static/media/sleepy.da4e495b7aef763ae8bbcf35a4d60a2d.svg";
export { ForwardRef as ReactComponent };